<template>
    <div>
        <div class="nonGraphContainer">
            <div class="pageHeader">
                <ContentHeader :name=this.headerName :subHeader="subHeader" />
                <button class="blue" @click="(event) => handleButtonPress(event)">New Event</button>
            </div>
            <!-- <Insights :cardInfo="cardInfo" /> -->
        </div>


        <div class="currentView">
            <v-sheet height="64">
                <v-toolbar flat width="100%" style="justify-content: space-between;">
                    <div>
                        <v-btn class="me-4" color="grey-darken-2" variant="outlined" @click="setToday">
                            Today
                        </v-btn>
                        <v-btn color="grey-darken-2" size="small" variant="text" icon @click="prev">
                            <v-icon size="small">
                                mdi-chevron-left
                            </v-icon>
                        </v-btn>
                        <v-btn color="grey-darken-2" size="small" variant="text" icon @click="next">
                            <v-icon size="small">
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                    </div>

                    <v-toolbar-title v-if="calendar">
                        {{ calendar.title }}
                    </v-toolbar-title>
                    <div>
                        <v-menu>
                            <template v-slot:activator="{ on }">
                                <v-list v-bind="on" style="flex-direction: row; display: flex;">
                                    <v-list-item @click="type = 'day'">
                                        <v-list-item-title>Day</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="type = 'week'">
                                        <v-list-item-title>Week</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item style="z-index: 2;" @click="type = 'month'">
                                        <v-list-item-title>Month</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </template>

                        </v-menu>
                    </div>

                </v-toolbar>
            </v-sheet>
            <VCalendar :ref="'calendar'" :start="calendarStartDate" title="June" is-expanded style="height:600px"
                :events="events" :type="type" @click:event="showEvent" />
            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement">
                <v-card color="grey lighten-4" min-width="350px" flat>
                    <v-toolbar :color="selectedEvent.color" dark>
                        <v-btn icon>
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <span>{{ selectedEvent.details }}</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="secondary" @click="selectedOpen = false">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </div>
    </div>

</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
// import Insights from "../../layout/Insights.vue";
import { VCalendar } from "vuetify/lib";

export default {

    components: {
        ContentHeader,
        // Insights,
        VCalendar
    },
    data() {
        return {
            selectedItem: Constants.INCIDENTS,
            headerName: Constants.CALENDAR,
            subHeader: "Below is a list of all upcoming events for Nautica!",
            events: [
                { name: 'Conference', start: '2025-06-10 10:00', end: '2025-06-10 12:00', color: "#00ff00" },
                { name: 'Party', start: '2025-06-11 19:00', end: '2025-06-11 22:00', color: "#00ffff" },
                {
                    name: 'Travel', start: '2025-06-12 08:00', end: '2025-06-16 17:00', color: "#87bab7",
                    style: "color:white"
                },
                { name: 'HOA Meeting', start: '2025-07-22 19:00', end: '2025-07-22 20:00', color: "#e3e3e3" },
                { name: 'Party', start: '2025-07-11 19:00', end: '2025-07-11 22:00', color: "#00ffff" },
                {
                    name: 'Saud OOO', start: '2025-07-06 08:00', end: '2025-07-06 17:00', color: "#87bab7",
                },
            ],
            calendarStartDate: new Date(),
            filters: [],
            tableData: [],
            search: "",
            cardInfo: null,
            calendar: this.$refs['calendar'],
            type: 'month',
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            showCalendarOptions: false

        };
    },
    created() {
        this.performSearch("Richard").then((apiData) => {
            console.log("Finished getting and setting API Data", apiData);
        });
    },
    mounted() {
        this.calendar = this.$refs['calendar']
    },
    methods: {
        performSearch() {

        },
        setToday() {
            console.log("Calendar", "Set Today")
            this.calendarStartDate = new Date()
        },
        next() {
            console.log("Calendar", "Next")
            switch (this.type) {
                case 'month': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth() + 2, 0)
                    break;

                }
                case 'day': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), this.calendarStartDate.getDate() + 1)
                    break;

                }
                case 'week': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), this.calendarStartDate.getDate() + 7)
                    break;

                }
            }

        },
        prev() {
            console.log("Calendar", "Prev")

            switch (this.type) {
                case 'month': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), 0)
                    break;
                }
                case 'day': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), this.calendarStartDate.getDate() - 1)
                    break;

                }
                case 'week': {
                    this.calendarStartDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), this.calendarStartDate.getDate() - 6)
                    break;

                }
            }
        },
        toggleCalendarOptionsView() {
            console.log("Calendar", "ShowCalendarOptions", this.showCalendarOptions)
            this.showCalendarOptions = !this.showCalendarOptions
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
    },
};
</script>

<style>
.pageHeader .blue {
    background-color: #1890FFCC;
    color: white;
}

.filterIcon {
    margin-right: 16px;
    display: inline;

}

.v-toolbar__content {
    justify-content: space-between !important;
    width: 100%;
}

.iconGroup {
    display: inline;
}
</style>